export const topSpaceForAppBar = "lg:mt-16";
export const bottomSpaceForAppBar = "mb-16 lg:mb-0";
export const defaultCardSizeClass = "max-h-24 my-2";
